import { Shark, /*Utils,*/ View } from "shark-mvc";

import tinymce from "tinymce/tinymce";
// eslint-disable-next-line no-unused-vars
import autoresize from "tinymce/plugins/autoresize";
// eslint-disable-next-line no-unused-vars
import link from "tinymce/plugins/link";
// eslint-disable-next-line no-unused-vars
import paste from "tinymce/plugins/paste";

import ImageContent from "../models/ImageContent";
import PlaceContent from "../models/PlaceContent";
import TextContent from "../models/TextContent";
import User from "../models/User";

// import contentFinderComponent from "../components/contentFinder/contentFinderComponent";
import contentsManager from "../controllers/contentsManager";
import dashboardView from "./dashboard/dashboardView";
import referenceVolumesComponent from "../components/referenceVolumes/referenceVolumesComponent";
import relatedContentsComponent from "../components/relatedContents/relatedContentsComponent";
import relatedLinksComponent from "../components/relatedLinks/relatedLinksComponent";
import tagsComponent from "../components/tags/tagsComponent";
import userManager from "../controllers/userManager";
import waitBoxComponent from "../components/waitBox/waitBoxComponent";

class ContentViewBase extends View {
	activeContentManager = null;
	loadingRemotePending = false;
	parseTagsAfterLoad = false;
	tagProcessed = false;
	
	constructor (viewName) {
		super(viewName);
	}

	afterLoadCommon (maintainWaitBoxOpen = false) {
		// if (!Shark.$store.currContent && !this.loadingRemotePending) {
		// 	Shark.openPage(dashboardView);
		// 	return;
		// }

		// Dave: Questo deve stare nel component
		// const tagContainer = document.querySelector("#tagsField");
		// new Tagify(tagContainer);

		// Dave: Mi sa che a causa dell'async nel beforeLoad questo succede prima di quello....
		// if (this.parseTagsAfterLoad) {
			// referenceVolumesComponent.setup();
			// tagsComponent.setup();
			// this.parseTagsAfterLoad = false;
		// }
		this.processTags();

		if (!maintainWaitBoxOpen) {
			waitBoxComponent.close();
		}
	}
	
	afterLoad () {
		this.afterLoadCommon();
	}

	// Dave: devo mettere "await" sul beforeLoad in Shark per geistre l'eventuale async, se no non va..
	async beforeLoad (contentManager, contentType) {
		waitBoxComponent.open();
		window.scrollTo(0, 0);

		const { userList } = Shark.get();

		if (!userList || userList.length === 0) {
			await userManager.getList()
			.then(response => {
				const userList = Shark.getInstanceList(User, response.data);

				Shark.set({ userList });
			});
		}

		if (!Shark.$store.currContent) {
			const urlParams = new URLSearchParams(document.location.search);

			if (urlParams.has("coguid")) {
				this.loadingRemotePending = true;
				waitBoxComponent.open();

				contentManager.getByGuid(urlParams.get("coguid"))
				.then(getByGuidResult => {
					this.loadingRemotePending = false;

					const currContent = new contentType(getByGuidResult?.data?.[0]);

					if (currContent) {
						Shark.set({
							currContent,
						});
						waitBoxComponent.close();

						if (this.contentLoaded) {
							this.contentLoaded();
						}
						else {
							Shark.render();
						}

						// this.parseTagsAfterLoad = false;

						//Dave: da rivedere con la nuova gestione degli eventi e dei listener
						this.processTags();
						this.getRelatorList();
					}
				});
			}
			else {
				Shark.openPage(dashboardView);
			}
		}
		else {
			this.processTags();
			this.getRelatorList();
		}

		Shark.set({
			isCreatingNewContent: false,
		});
	}

	beforeUnload () {
		if (!Shark.$store.isCreatingNewContent) {
			Shark.set({
				currContent: null,
			});
		}
	}

	deleteCurrContentBtn_clickHandler () {
		const { currContent } = Shark.get();

		if (currContent && confirm(`Vuoi davvero eliminare definitivamente "${currContent.title}"?\n\nNon sarà possibile annullare!`)) {
			this.deleteContent(currContent.guid);
		}
	}

	getRelatorList () {
		const { currContent } = Shark.get();
		
		if (currContent && currContent.guid !== "") {
			contentsManager.getRelatorContentList(currContent.guid)
			.then(relatorListResponse => {
				console.log({relatorListResponse});

				const images = Shark.getInstanceList(ImageContent, relatorListResponse.data.images);
				const places = Shark.getInstanceList(PlaceContent, relatorListResponse.data.places);
				const texts = Shark.getInstanceList(TextContent, relatorListResponse.data.texts);

				images.forEach(item => item.type = "image");
				places.forEach(item => item.type = "place");
				texts.forEach(item => item.type = "text");

				currContent.__relatorList = [...images, ...places, ...texts];
				Shark.render();
			});
		}
	}

	init () {
		this.addComponents([relatedContentsComponent, relatedLinksComponent, referenceVolumesComponent, tagsComponent, waitBoxComponent]);

		Shark.set({
			customTagsCategoryList: Shark.$store.customTagsCategoryList || [],
		});
	}

	processTags () {
		const referenceVolumesProcessed = referenceVolumesComponent.setup();
		const tagsProcessed = tagsComponent.setup();
	
		this.tagProcessed = referenceVolumesProcessed && tagsProcessed;
	}

	saveCurrContentBtn_clickHandler () {
		this.saveCurrContent();
	}

	saveCurrContentAndCreateNewBtn_clickHandler () {
		this.saveCurrContentAndCreateNew();
	}

	setupEditor () {
		const { currContent } = Shark.get();

		tinymce.remove("textarea#bodyField");
		tinymce.init({
			autoresize_bottom_margin: 20,
			convert_urls : true,
			max_height: window.innerHeight * .55,
			min_height: 300,
			paste_as_text: true,
			paste_data_images: false,
			plugins: "autoresize link paste",
			relative_urls: false,
			remove_script_host : false,
			selector: "textarea#bodyField",
			toolbar: [
				"undo redo | styleselect | bold italic | alignleft aligncenter alignright | link"
			],
			init_instance_callback: (editor) => {
				Shark.set({
					__contentViewTinymceEditor: editor
				});

				editor.on("input", () => {
					currContent.set({
						[currContent._mainEditorField]: editor.getContent(),
						textBody: editor.getContent({format: "text"}),
					});
					console.log({currContent});
				});

				if (currContent.textBody !== undefined && currContent.textBody === "") {
					currContent.set({
						textBody: Shark.$store.__contentViewTinymceEditor.getContent({format: "text"}),
					});
				}
	
				waitBoxComponent.close();
			}, 
		});
		this.tinyInited = true;
	}
}

export default ContentViewBase;
